// 재입고(상품 판매) 알림 섹션 URL (2026-11-01 KST 추가)
export const restockAlarmsPath = "/restock-alarms";
